export function removeClassFromList(elementList, className) {
  let  i, elementListLength, arrNo = [];
  elementListLength = elementList.length;
  for (i = 0; i < elementListLength; i++) {
    if (arrNo.indexOf(i)) {
      elementList[i].classList.remove(className);
    }
  }
}

export function toggleClass(elementList, className) {
  if (elementList.classList.contains(className)) {
    elementList.classList.remove(className);
  } else {
    elementList.classList.add(className);
  }
}

export function numbers_only(value) {
  return value.replace(/[^0-9]/g, '')
}
